<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="parentGroup">
  <fieldset *ngIf="!isInstaMed()" formGroupName="merchantAddress">
    <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
      <label class="col-md-8 control-label" for="address1">
        Address Line 1
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          name="address1"
          id="address1"
          formControlName="address1"
          [ngClass]="{
            'is-invalid':
              merchantAddressFormControls.address1.invalid &&
              (merchantAddressFormControls.address1.dirty ||
                merchantAddressFormControls.address1.touched)
          }"
        />
        <div
          class="mt-1"
          *ngIf="
            merchantAddressFormControls.address1.invalid &&
            (merchantAddressFormControls.address1.dirty ||
              merchantAddressFormControls.address1.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="merchantAddressFormControls.address1.errors?.required"
          >
            Field is required.
          </div>
          <div
            class="text-danger"
            *ngIf="merchantAddressFormControls.address1.errors?.maxlength"
          >
            Content is too long. Please shorten it.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-8 control-label" for="address2">
        Address Line 2
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          name="address2"
          id="address2"
          formControlName="address2"
          [ngClass]="{
            'is-invalid':
              merchantAddressFormControls.address2.invalid &&
              (merchantAddressFormControls.address2.dirty ||
                merchantAddressFormControls.address2.touched)
          }"
        />
        <div
          *ngIf="
            merchantAddressFormControls.address2.invalid &&
            (merchantAddressFormControls.address2.dirty ||
              merchantAddressFormControls.address2.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="merchantAddressFormControls.address2.errors?.maxlength"
          >
            Content is too long. Please shorten it.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
      <label class="col-md-8 control-label" for="city"> City </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          name="city"
          id="city"
          formControlName="city"
          [ngClass]="{
            'is-invalid':
              merchantAddressFormControls.city.invalid &&
              (merchantAddressFormControls.city.dirty ||
                merchantAddressFormControls.city.touched)
          }"
        />
        <div
          class="mt-1"
          *ngIf="
            merchantAddressFormControls.city.invalid &&
            (merchantAddressFormControls.city.dirty ||
              merchantAddressFormControls.city.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="merchantAddressFormControls.city.errors?.required"
          >
            Field is required.
          </div>
          <div
            class="text-danger"
            *ngIf="merchantAddressFormControls.city.errors?.maxlength"
          >
            Content is too long. Please shorten it.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
      <label class="col-md-8 control-label" for="state"> State </label>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-8">
            <select
              class="form-control"
              name="state"
              id="state"
              formControlName="state"
              [ngClass]="{
                'is-invalid':
                  merchantAddressFormControls.state.invalid &&
                  (merchantAddressFormControls.state.dirty ||
                    merchantAddressFormControls.state.touched)
              }"
            >
              <option value="">--- Select State ---</option>
              <option
                *ngFor="let state of states | keyvalue"
                [value]="state.key"
              >
                {{ state.value }}
              </option>
            </select>
            <div
              class="mt-1"
              *ngIf="
                merchantAddressFormControls.state.invalid &&
                (merchantAddressFormControls.state.dirty ||
                  merchantAddressFormControls.state.touched)
              "
            >
              <div
                class="text-danger"
                *ngIf="merchantAddressFormControls.state.errors?.required"
              >
                Field is required.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
      <label class="col-md-8 control-label" for="zip"> Zip </label>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-4">
            <input
              class="form-control"
              type="text"
              name="zip"
              id="zip"
              formControlName="zip"
              [ngClass]="{
                'is-invalid':
                  merchantAddressFormControls.zip.invalid &&
                  (merchantAddressFormControls.zip.dirty ||
                    merchantAddressFormControls.zip.touched)
              }"
            />
          </div>
        </div>
        <div
          class="mt-1"
          *ngIf="
            merchantAddressFormControls.zip.invalid &&
            (merchantAddressFormControls.zip.dirty ||
              merchantAddressFormControls.zip.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="merchantAddressFormControls.zip.errors?.required"
          >
            Field is required.
          </div>
          <div
            class="text-danger"
            *ngIf="merchantAddressFormControls.zip.errors?.pattern"
          >
            Invalid Zip, must be a number.
          </div>
          <div
            class="text-danger"
            *ngIf="merchantAddressFormControls.zip.errors?.maxlength"
          >
            Max length is 11.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
      <label class="col-md-8 control-label" for="country"> Country </label>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-8">
            <select
              class="form-control"
              name="country"
              id="country"
              formControlName="country"
              [ngClass]="{
                'is-invalid':
                  merchantAddressFormControls.country.invalid &&
                  (merchantAddressFormControls.country.dirty ||
                    merchantAddressFormControls.country.touched)
              }"
            >
              <option value="">--- Select Country ---</option>
              <option
                *ngFor="let country of countries | keyvalue"
                [value]="country.key"
              >
                {{ country.value }}
              </option>
            </select>
            <div
              class="mt-1"
              *ngIf="
                merchantAddressFormControls.country.invalid &&
                (merchantAddressFormControls.country.dirty ||
                  merchantAddressFormControls.country.touched)
              "
            >
              <div
                class="text-danger"
                *ngIf="merchantAddressFormControls.country.errors?.required"
              >
                Field is required.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset *ngIf="!isInstaMed()">
    <div class="col-12 mt-4">
      <legend>
        <label class="checkbox-inline">
          <input
            type="checkbox"
            [checked]="showRemit"
            (change)="updateShowRemit()"
          />
          Remit-to Address
        </label>
      </legend>
    </div>

    <div class="animate-show" *ngIf="showRemit" formGroupName="remitToAddress">
      <div class="form-group">
        <label class="col-md-8 control-label" for="remitMerchantName">
          Merchant Name
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            id="remitMerchantName"
            formControlName="merchantName"
            [ngClass]="{
              'is-invalid':
                remitToAddressFormControls.merchantName.invalid &&
                (remitToAddressFormControls.merchantName.dirty ||
                  remitToAddressFormControls.merchantName.touched)
            }"
          />
          <div
            class="mt-1"
            *ngIf="
              remitToAddressFormControls.merchantName.invalid &&
              (remitToAddressFormControls.merchantName.dirty ||
                remitToAddressFormControls.merchantName.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="remitToAddressFormControls.merchantName?.errors?.maxlength"
            >
              Content is too long. Please shorten it.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-8 ml-3 mt-4">
          <button
            class="btn btn-primary btn-xs float-right"
            type="button"
            (click)="copyMerchantAddressToRemitAddress()"
          >
            <fa-icon [icon]="faCopy"></fa-icon>
            Copy Address from Merchant Address section
          </button>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: showRemit }">
        <label class="col-md-8 control-label"> Address Line 1 </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            id="remitAddressLine1"
            formControlName="address1"
            [ngClass]="{
              'is-invalid':
                remitToAddressFormControls.address1.invalid &&
                (remitToAddressFormControls.address1.dirty ||
                  remitToAddressFormControls.address1.touched)
            }"
          />
          <div
            *ngIf="
              remitToAddressFormControls.address1.invalid &&
              (remitToAddressFormControls.address1.dirty ||
                remitToAddressFormControls.address1.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="remitToAddressFormControls.address1.errors?.required"
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="remitToAddressFormControls.address1.errors?.maxlength"
            >
              Content is too long. Please shorten it.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-8 control-label" for="remitAddressLine2">
          Address Line 2
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            id="remitAddressLine2"
            formControlName="address2"
            [ngClass]="{
              'is-invalid':
                remitToAddressFormControls.address2.invalid &&
                (remitToAddressFormControls.address2.dirty ||
                  remitToAddressFormControls.address2.touched)
            }"
          />
          <div
            *ngIf="
              remitToAddressFormControls.address2.invalid &&
              (remitToAddressFormControls.address2.dirty ||
                remitToAddressFormControls.address2.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="remitToAddressFormControls.address2.errors?.maxlength"
            >
              Content is too long. Please shorten it.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: showRemit }">
        <label class="col-md-8 control-label" for="remitCity"> City </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            id="remitCity"
            formControlName="city"
            maxlength="49"
            [ngClass]="{
              'is-invalid':
                remitToAddressFormControls.city.invalid &&
                (remitToAddressFormControls.city.dirty ||
                  remitToAddressFormControls.city.touched)
            }"
          />

          <div
            class="mt-1"
            *ngIf="
              remitToAddressFormControls.city.invalid &&
              (remitToAddressFormControls.city.dirty ||
                remitToAddressFormControls.city.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="remitToAddressFormControls.city.errors?.required"
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="remitToAddressFormControls.city.errors?.maxlength"
            >
              Content is too long. Please shorten it.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: showRemit }">
        <label class="col-md-8 control-label" for="remitState"> State </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-8">
              <select
                class="form-control"
                id="remitState"
                formControlName="state"
                [ngClass]="{
                  'is-invalid':
                    remitToAddressFormControls.state.invalid &&
                    (remitToAddressFormControls.state.dirty ||
                      remitToAddressFormControls.state.touched)
                }"
              >
                <option value="">--- Select State ---</option>
                <option
                  *ngFor="let state of states | keyvalue"
                  [value]="state.key"
                >
                  {{ state.value }}
                </option>
              </select>
              <div
                class="mt-1"
                *ngIf="
                  remitToAddressFormControls.state.invalid &&
                  (remitToAddressFormControls.state.dirty ||
                    remitToAddressFormControls.state.touched)
                "
              >
                <div
                  class="text-danger"
                  *ngIf="remitToAddressFormControls.state.errors?.required"
                >
                  Field is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: showRemit }">
        <label class="col-md-8 control-label" for="remitZip"> Zip </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-4">
              <input
                class="form-control"
                type="text"
                id="remitZip"
                formControlName="zip"
                [ngClass]="{
                  'is-invalid':
                    remitToAddressFormControls.zip.invalid &&
                    (remitToAddressFormControls.zip.dirty ||
                      remitToAddressFormControls.zip.touched)
                }"
              />
              <div
                class="mt-1"
                *ngIf="
                  remitToAddressFormControls.zip.invalid &&
                  (remitToAddressFormControls.zip.dirty ||
                    remitToAddressFormControls.zip.touched)
                "
              >
                <div
                  class="text-danger"
                  *ngIf="remitToAddressFormControls.zip.errors?.required"
                >
                  Field is required.
                </div>
                <div
                  class="text-danger"
                  *ngIf="remitToAddressFormControls.zip.errors?.pattern"
                >
                  Invalid Zip, must be a number.
                </div>
                <div
                  class="text-danger"
                  *ngIf="remitToAddressFormControls.zip.errors?.maxlength"
                >
                  Content is too long. Please shorten it.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: showRemit }">
        <label class="col-md-8 control-label" for="remitCountry">
          Country
        </label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-8">
              <select
                class="form-control"
                id="remitCountry"
                formControlName="country"
                [ngClass]="{
                  'is-invalid':
                    remitToAddressFormControls.country.invalid &&
                    (remitToAddressFormControls.country.dirty ||
                      remitToAddressFormControls.country.touched)
                }"
              >
                <option value="">--- Select Country ---</option>
                <option
                  *ngFor="let country of countries | keyvalue"
                  [value]="country.key"
                >
                  {{ country.value }}
                </option>
              </select>
              <div
                class="mt-1"
                *ngIf="
                  remitToAddressFormControls.country.invalid &&
                  (remitToAddressFormControls.country.dirty ||
                    remitToAddressFormControls.country.touched)
                "
              >
                <div
                  class="text-danger"
                  *ngIf="remitToAddressFormControls.country.errors?.required"
                >
                  Field is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
